import Template from "./template";
import paper from "paper";
import ComponentPort from "../core/componentPort";
import { LogicalLayerType } from "../core/init";

export default class Gelchannel extends Template {
    constructor() {
        super();
    }

    __setupDefinitions(): void  {
        this.__unique = {
            position: "Point"
        };

        this.__heritable = {
            componentSpacing: "Float",
            sideWidth: "Float",
            mainWidth: "Float",
            rotation: "Float",
            length: "Float",
            depth: "Float",
            sideheight: "Float",
            mirrorByX: "Float",
            mirrorByY: "Float"
        };

        this.__defaults = {
            componentSpacing: 2000,
            sideWidth: 200,
            mainWidth: 500,
            rotation: 0,
            length: 3000,
            depth: 250,
            sideheight: 50,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__units = {
            componentSpacing: "μm",
            sideWidth: "μm",
            mainWidth: "μm",
            rotation: "°",
            length: "μm",
            depth: "μm",
            sideheight: "μm"
        };

        this.__minimum = {
            componentSpacing: 0,
            sideWidth: 20,
            mainWidth: 10,
            length: 1000,
            depth: 10,
            sideheight: 10,
            rotation: 0,
            mirrorByX: 0,
            mirrorByY: 0
        };

        this.__maximum = {
            componentSpacing: 10000,
            sideWidth: 500,
            mainWidth: 500,
            length: 100 * 1000,
            depth: 1200,
            sideheight: 1200,
            rotation: 360,
            mirrorByX: 1,
            mirrorByY: 1
        };

        this.__featureParams = {
            componentSpacing: "componentSpacing",
            position: "position",
            rotation: "rotation",
            length: "length",
            sideWidth: "sideWidth",
            mainWidth: "mainWidth",
            depth: "depth",
            sideheight: "sideheight",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__targetParams = {
            componentSpacing: "componentSpacing",
            rotation: "rotation",
            length: "length",
            sideWidth: "sideWidth",
            mainWidth: "mainWidth",
            depth: "depth",
            sideheight: "sideheight",
            mirrorByX: "mirrorByX",
            mirrorByY: "mirrorByY"
        };

        this.__placementTool = "CellPositionTool";

        this.__toolParams = {
            position: "position"
        };

        this.__renderKeys = ["FLOW", "CELL"];

        this.__mint = "GEL CHANNEL";

        this.__zOffsetKeys = {
            FLOW: "depth",
            CELL: "sideHeight"
        };

        this.__substrateOffset = {
            FLOW: "0",
            CELL: "0"
        };
    }

    getPorts(params: { [k: string]: any }) {
        const ports = [];
        const sideWidth = params.sideWidth;
        const numChambers = 2;
        const length = params.length;
        const mainWidth = params.mainWidth;

        ports.push(new ComponentPort(0, sideWidth + mainWidth / 2, "1", LogicalLayerType.FLOW));
        ports.push(new ComponentPort((numChambers / 2) * (length + 60) + 60, sideWidth + mainWidth / 2, "2", LogicalLayerType.FLOW));

        return ports;
    }

    render2D(params: { [k: string]: any }, key: string) {
        if (key === "FLOW") {
            return this.__drawFlow(params);
        } else if (key === "CELL") {
            return this.__drawCell(params);
        }

        throw new Error("Unknown key: " + key);

    }

    render2DTarget(key: string | null, params: { [k: string]: any }) {
        const traps = this.__drawFlow(params);
        traps.addChild(this.__drawCell(params));
        traps.fillColor!.alpha = 0.5;
        return traps;
    }

    __drawFlow(params: { [k: string]: any }) {
        const rotation = params.rotation;
        const position = params.position;
        const sideWidth = params.sideWidth;
        const numChambers = 2;
        const length = params.length;
        const mainWidth = params.mainWidth;

        console.log(rotation, position, sideWidth, numChambers, length, mainWidth, 60);
        const color = params.color;
        const x = position[0];
        const y = position[1];
        const chamberList = new paper.CompoundPath("");
        chamberList.fillColor = color;
        let traps;
        let channels;

        const startPoint = new paper.Point(x, y + sideWidth);
        channels = new paper.Path.Rectangle({
            point: startPoint,
            size: [(numChambers / 2) * (length + 60) + 60, mainWidth],
            fillColor: color,
            strokeWidth: 0
        });
        chamberList.addChild(channels);

        traps = new paper.CompoundPath(chamberList);
        traps.fillColor = color;
        const center = new paper.Point(position[0], position[1]);
        this.transformRender(params,traps);
        return traps;
    }

    __drawCell(params: { [k: string]: any }) {
        const rotation = params.rotation;
        const position = params.position;
        const sideWidth = params.sideWidth;
        const numChambers = 2;
        const length = params.length;
        const mainWidth = params.mainWidth;
        const color = params.color;
        const x = position[0];
        const y = position[1];
        const chamberList = new paper.CompoundPath("");
        let rec;

        for (let i = 0; i < numChambers / 2; i++) {
            const startPoint = new paper.Point(x + i * (length + 60) + 60, y);
            rec = new paper.Path.Rectangle({
                size: [length, 2 * sideWidth + mainWidth],
                point: startPoint,
                fillColor: color,
                strokeWidth: 0
            });
            chamberList.addChild(rec);
        }

        chamberList.fillColor = color;
        const center = new paper.Point(x, y);
        this.transformRender(params,chamberList);
        return chamberList;
    }
}
